import { Component, Input } from '@angular/core'
import { CommonModule } from '@angular/common'
import { Router } from '@angular/router'
import { AgentAuthService } from '../../services/agent-auth.service'

@Component({
    selector: 'app-agent-header',
    imports: [CommonModule],
    templateUrl: './agent-header.component.html',
    styleUrls: ['./agent-header.component.scss']
})
export class AgentHeaderComponent {
  @Input() activeStep: number = 2
  @Input() mobileTitle: string = 'Test taker details'
  @Input() showAgentBadge: boolean = false

  showProfileDropdown = false

  steps = [
    { label: 'Choose test', order: 1 },
    { label: 'Test taker details', order: 2 },
    { label: 'Review', order: 3 },
    { label: 'Payment', order: 4 },
    { label: 'Confirmation', order: 5 }
  ]

  constructor (
    private agentAuthService: AgentAuthService,
    private router: Router
  ) {}

  isCompleted(step: { order: number }): boolean {
    return step.order < this.activeStep
  }

  isActive(step: { order: number }): boolean {
    return step.order === this.activeStep
  }

  toggleDropdown (): void {
    this.showProfileDropdown = !this.showProfileDropdown
  }

  async signOut (): Promise<void> {
    this.showProfileDropdown = false
    await this.agentAuthService.signOut()
    this.router.navigate(['/agent/logged-out'])
  }
}
